/** La guía verde del escáner, en fracciones del recuadro donde se ve el video. */
export const GUIA = { izq: 0.06, der: 0.06, arriba: 0.34, abajo: 0.34 };

/**
 * Qué parte del cuadro de la cámara (en píxeles del video) cae dentro de la
 * guía verde. El video se ve con `object-fit: cover` y, con zoom digital,
 * escalado `zoom` veces desde el centro; las dos cosas cambian qué píxeles
 * reales quedan bajo la guía.
 */
export function recorteGuia(
  video: { ancho: number; alto: number },
  caja: { ancho: number; alto: number },
  zoom = 1,
) {
  const escala = Math.max(caja.ancho / video.ancho, caja.alto / video.alto) * zoom;
  const aVideoX = (x: number) => video.ancho / 2 + (x - caja.ancho / 2) / escala;
  const aVideoY = (y: number) => video.alto / 2 + (y - caja.alto / 2) / escala;
  const x = aVideoX(caja.ancho * GUIA.izq);
  const y = aVideoY(caja.alto * GUIA.arriba);
  return {
    x: Math.round(x),
    y: Math.round(y),
    w: Math.round(aVideoX(caja.ancho * (1 - GUIA.der)) - x),
    h: Math.round(aVideoY(caja.alto * (1 - GUIA.abajo)) - y),
  };
}
